/**
 * @file getQuestionIndex.ts
 * Exports a method that fetches the index of object within the questions array.
 */
import { findIndex, propEq } from 'ramda';
import { getQuestions } from '.';
import type { AppState } from '../types';

/**
 * Helper method that returns the index of object within the questions array.
 *
 * Currently this is used to display the progress of a user as they complete the
 * assessment; that is, the user is at question 3 of 7. In the future this may
 * require additional logic when conditional questions are employed.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 * @param {string} id
 *   The id of a question in the questions data.
 *
 * @returns {number|undefined}
 *   The position of the question within the questions array.
 */
export default (appState: AppState, id: string): number =>
  findIndex(propEq('id', id))(getQuestions(appState));
